module.exports = __webpack_public_path__ + "static/media/collection2.12db7603.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Home/collection2.png
// module id = 552
// module chunks = 0